
<button type="button" class="btn blue-btn btn-sm butstyle " data-target="#printalert" data-toggle="modal">
  <i class="fa fa-print"> </i>Print
</button>

<!--================================ print Model============================================-->
<span id="printalertOpen" data-target="#printalert" data-toggle="modal"></span>
<div class="modal fade" id="printalert" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog create-update-zip" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Print confirmation</h5>
        <button type="button" class="close"  (click)="printalertOpen()">&times;</button>
      </div>
      <div class="modal-body">
        Do you want to print this record ?
      </div>
      <div class="modal-footer">

        <button class="btn blue-btn btn-sm butstyle " (click)="printData()">Print
        </button>
        <button class="btn blue-btn btn-sm butstyle " (click)="printalertOpen()">Cancel</button>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-lg-12">
    <table class="table table-sm table-hover table-bordered" id="tablerecords"> 
      <thead class="bg-primary text-white">
        <tr>
          <th class="pointer">Name</th>
          
          <th class="pointer">Last Eligibility Check</th>
          <!-- <th class="pointer">DOB</th>
          <th class="pointer">Medicaid</th> -->
          <th class="pointer">MA Eligible</th>
          <th class="pointer">PMAP</th>
          <th class="pointer">Program</th>
          <th class="pointer">Waiver</th>
          <th class="pointer">SpendDown</th>
          <th class="pointer">MSHO</th>
       
         
        </tr>
      </thead>
      <tbody >
        <tr class="row1" *ngFor="let s of EDI271Client;let i=index" >
          <td rowspan="2" *ngIf="i == 0">
            {{s.clientName}}
          </td>
          <td >
            {{s.lastEligibilityCheck | date}}
          </td>
          <!-- <td >
            {{s.dob | date}}
          </td>
          <td >
            {{s.medicaid}}
          </td> -->
          <td >
            {{s.isMAEligible}}
          </td>
          
          <td >
            {{s.pmap}}
          </td>

          <td >
            {{s.program}}
          </td>
          <td >
            {{s.waiver}}
          </td>
          <td >
            {{s.spendDown}}
          </td>
          <td >
            {{s.msho}}
          </td>
         
         
        </tr>

       
      </tbody>

    </table>
    <div *ngIf="rownum == 0" class="text-primary text-center">
      <p>No data available</p>
    </div>
  </div>
</div>

